import { defineComponent as _defineComponent } from 'vue'
import CollapsableCard from "@/components/bootstrap/CollapsableCard.vue";
import Toggle from "@/components/bootstrap/Toggle.vue";
import {debounce, toBase64} from "@/utils/Helpers";
import { inject, ref, watch } from "vue";
import {BrandingConfig} from "@/models/NutritionLabels/BrandingConfig";
import VDragAndDropUpload from "@/components/vDragAndDropUpload.vue";
import RecipesRepository from "@/utils/API/RecipesRepository";
import {useNotify} from "@/hooks/useNotify";
import {useTranslations} from "@/hooks/useTranslations";
import restaurantRepository from "@/utils/API/RestaurantRepository";


export default /*#__PURE__*/_defineComponent({
  __name: 'TextEditorConfiguration',
  props: {
    value: null,
    recipeId: null,
    stepCounter: { default: "7" }
  },
  emits: ["input"],
  setup(__props: any, { emit }) {

const props = __props as { value: BrandingConfig, recipeId: number, stepCounter: string };

const fetchPreview = inject("bopFetchPreview") as () => void;
const notify = useNotify();
const translations = useTranslations();




const localConfig = ref<BrandingConfig>({
  showLogo: false,
  logoPosition: "top-right",
  textTop: "",
  textBottom: "",
  showImage: false,
  imagePosition: "bottom-right",
});

const logoPositionOptions = [
  { value: "top-left", text: "Top Left" },
  { value: "top-right", text: "Top Right" },
  { value: "top-centre", text: "Top Centre" },
];

const imagePositionOptions = [
  { value: "bottom-left", text: "Bottom Left" },
  { value: "bottom-right", text: "Bottom Right" },
  { value: "bottom-centre", text: "Bottom Centre" },
];

watch(
  () => props.value,
  (val) => {
    localConfig.value = {
      showImage: false,
      showLogo: false,
      logoPosition: "top-right",
      textTop: "",
      textBottom: "",
      ...(val || {})
    };
  },
  { deep: true, immediate: true }
);

function onToggleLogo(val: boolean) {
  localConfig.value.showLogo = val;
  emitUpdate();
}

function onToggleImage(val: boolean) {
  localConfig.value.showImage = val;
  emitUpdate();
}

async function handleBrandingFileUpload(files: File[]){
  const file = files[0];
  const fileAsBase64 = await toBase64(file);
  let notifTranslationKey;
  try {
    await restaurantRepository.updateRestaurantBrandingLogo(fileAsBase64);
    notifTranslationKey = "ms_save_success";

    localConfig.value.showLogo = true;
    emitUpdate();
  }
  catch {
    notifTranslationKey = "ms_save_file_fail";
  }

  notify.success(translations.value.get(notifTranslationKey));
}

async function handleFileUpload(files: File[]) {
  const file = files[0];
  const fileAsBase64 = await toBase64(file);
  let notifTranslationKey;
  try {
    await RecipesRepository.updateRecipeImageData(props.recipeId ,fileAsBase64);
    notifTranslationKey = "ms_save_success";

    localConfig.value.showImage = true;
    emitUpdate();
  }
  catch {
    notifTranslationKey = "ms_save_file_fail";
  }

  notify.success(translations.value.get(notifTranslationKey));
}

function onConfigChanged() {
  emitUpdate();
}

function emitUpdate() {
  emit("input", { ...localConfig.value });
  debouncedFetchPreview();
}

function debouncedFetchPreview() {
  if (fetchPreview) {
    debounce(fetchPreview, 800, "branding-logo-update");
  }
}

return { __sfc: true,fetchPreview, notify, translations, props, emit, localConfig, logoPositionOptions, imagePositionOptions, onToggleLogo, onToggleImage, handleBrandingFileUpload, handleFileUpload, onConfigChanged, emitUpdate, debouncedFetchPreview, CollapsableCard, Toggle, VDragAndDropUpload }
}

})